const baseUrl = process.env.STRAPI_BASE_URL;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetcher = async <T = any>(
  endpoint: string,
  options?: RequestInit,
  config?: { nullOn404?: boolean }
): Promise<T> => {
  const url = new URL(endpoint, baseUrl);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);

  try {
    const response = await fetch(url, {
      next: { revalidate: 3600 }, // Cache for 1 hour, then revalidate
      signal: controller.signal,
      headers: {
        Authorization: `Bearer ${process.env.STRAPI_AUTH_TOKEN}`,
        ...options?.headers
      },
      ...options
    });

    if (!response.ok) {
      // A 404 is an expected "not present yet" state for optional / phased-rollout content
      // (an empty Strapi single type, or an API not yet deployed). Return null without logging.
      if (config?.nullOn404 && response.status === 404) {
        return null as T;
      }
      throw new Error(response.statusText);
    }

    return await response.json();
  } catch (err) {
    console.error('Fetch error:', err);
    throw err;
  } finally {
    clearTimeout(timeout);
  }
};
